import actionTypes from '../constants/actionTypes'

export default function standingsReducer(state = {}, action) {

  switch(action.type) {
    case actionTypes.GET_STANDINGS:
      return Object.assign({}, state, {
        ...action.data
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../app/reducers/standings.js